module.exports = __webpack_public_path__ + "static/media/trial2_2.ad19ad75.png";